import styled from 'styled-components';
import { COLORS } from '../../colors';

const StyledLoginModal = styled.div`
  background-color: ${COLORS.lightGray};
  color: ${COLORS.darkerBlue};
  padding: 2rem;
  box-sizing: border-box;
  text-align: center;
  max-width: 400px;

  border-radius: 12px;

  .titles {
    margin-bottom: 1rem;
  }

  .select {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    p.disclaimer {
      font-size: 12px;
    }
  }

  .login {
    padding-top: 1rem;
    display: flex;
    flex-direction: column;
    input {
      padding: 1rem;
      font-size: 16px;
      border-radius: 12px;
      margin-bottom: 1rem;
      text-align: center;
    }
    .buttons {
      display: flex;
      flex-direction: column;
    }
    button.forget {
      background-color: transparent;
      border: none;
      text-decoration: underline;
      margin-bottom: 1rem;
      cursor: pointer;
    }
  }

  .signup {
    .inputs {
      padding-top: 1rem;
      display: flex;
      flex-direction: column;
      input {
        margin-bottom: 1rem;
      }
    }
    .buttons {
      display: flex;
      flex-direction: column;
    }
  }

  .accountQuestion {
    div {
      display: flex;
      flex-direction: column;
    }

    .buttons {
      display: flex;
      flex-direction: column;
    }
  }

  .forget {
    .buttons {
      display: flex;
      flex-direction: column;
    }
  }

  .verify {
    .buttons {
      display: flex;
      flex-direction: column;
    }
  }
`

export {
  StyledLoginModal
}